<template>
  <div class="sub-categories">
    <span class="title">Subcategories</span>
    <div class="stick-to-top">
      <div class="group" :class="{'has-selected-category': true}">
        <span @click="expanded = !expanded">
          Sortering
          <fa v-if="expanded" icon="caret-up" />
          <fa v-else icon="caret-down" />
        </span>
        <div class="group-container" v-show="expanded">
          <recipe-order />
        </div>
      </div>
      <sub-category-group v-for="(group, index) in subCategories" :key="index" :group="group" />
    </div>
  </div>
</template>

<script>
import SubCategoryGroup from "./SubCategoryGroup";
import RecipeOrder from "../recipe/RecipeOrder";
export default {
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    subCategories() {
      return this.$store.getters.subCategoriesInSelectedCategories;
    }
  },
  components: {
    "sub-category-group": SubCategoryGroup,
    "recipe-order": RecipeOrder
  }
};
</script>

<style lang="scss" scoped>
  .title{
    text-align: center;
    padding-left: 15px;
    display: block;
    @media(max-width: 800px){
      padding-left: 0;
    }
  }
</style>